var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"MItemEntryCustomFieldLabel"},[_c('div',{staticClass:"mr-2 font-caption"},[_vm._v(" "+_vm._s(_vm.fieldNumber)+" "+_vm._s(_vm.unit ? `(${_vm.unit})` : '')+" ")]),_c('div',{staticClass:"field-label"},[_vm._v(" "+_vm._s(_vm.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }